import React from 'react';
import $ from "jquery";

import logo from '../assets/images/icons/white-logo.svg';
import mybaLogo from '../assets/images/mybalogo.png';
import buttonarrow from '../assets/images/icons/button-arrow.svg';
import { Link } from "react-router-dom";

class Footer extends React.Component {
    constructor(props) {
        super(props);
        this.state ={
            email: ''
        };

    }

    render(){
        return (
            <section id="section7" className="section fix footer">
            <div className="container">
                <div className="row">
                    <div className="col-lg-2 col-md-4 col-sm-12 col-12 no-padding mtp footer-logo-div">
                        <div className="footer-logo">
                            <Link to="/">EXCLUSIVE GULETS</Link>
                        </div>
                        <p className="copyright-txt mt-4">
                            Level 1, Devonshire House <br />
                            One Mayfair Place <br />
                            Mayfair, London <br/>
                            W1J 8AJ, ENGLAND <br /> <br />
                            info@exclusivegulets.com <br />
                            t. +44 208 144 58 34 <br />
                        </p>
                    </div>
                    <div className="col-lg-6 col-md-8">
                        <div className="footer-nav">
                            <ul>
                                <li><Link to="/search">Browse</Link></li>
                                <li><Link to={{ pathname: "/search", category: "sale"}} >For Sale</Link></li>
                                <li><Link to={{ pathname: "/search", category: "charter"}}>For Charter</Link></li>
                                <li><Link to="/why-charter">Why Charter?</Link></li>
                                <li><Link to="/destinations">Destinations</Link></li>
                                <li><Link to="/blog">Blog</Link></li>
                                <li><Link to="/signin">Sign In</Link></li>
                                <li><Link to="/signup">Sign Up</Link></li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-7 col-sm-12 col-12 no-padding newsletter-div mtp">
                        <div className="footer-newsletter">
                            <h2>Yacht-Style Newsletter</h2>
                            <p>If you like yachts you need this newsletter in your life</p>
                            <form action={`https://exclusivegulets.us2.list-manage.com/subscribe/post?u=f7824079090aff6599df74c4c&amp;id=8f64808314&EMAIL=${this.state.email}`} method="post" target="_blank" noValidate>
                            <div className="input-group">
                                <input type="email" name="EMAIl" value={this.state.email} onChange={ (e)=>{this.setState({email: e.target.value});} } className="form-control" placeholder="your@email.com"/>
                                <span className="input-group-btn">
                                    <button className="btn btn-secondary newsletter-btn" type="submit">
                                        <span>Submit</span>
                                        <div className="button-arrow">
                                            <img src={buttonarrow} className="img-responsive" alt="arrow"/>
                                        </div>
                                    </button>
                                </span>
                            </div>
                            </form>
                            <ul className="footer-socila">
                                <li><a href={this.props.general_content.fields.facebook_link}><i className="fa fa-facebook"></i></a></li>
                                <li><a href={this.props.general_content.fields.instagram_link}><i className="fa fa-instagram"></i></a></li>
                                <li><a href={this.props.general_content.fields.linkedin_link}><i className="fa fa-linkedin"></i></a></li>
                                <li><a href={this.props.general_content.fields.twitter_link}><i className="fa fa-twitter"></i></a></li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="row copyright" id="for_deskftr">
                    <div className="col-lg-6 col-md-6">
                        <p className="copyright-txt">Copyright 2019 - EXCLUSIVE GULETS</p>
                    </div>
                    <div className="col-lg-6 col-md-6">
                        <ul className="copyright-menu">
                            <li><Link to="/privacy">Privacy</Link></li>
                            <li><Link to="/terms">Terms and conditions</Link></li>
                        </ul>
                    </div>
                </div>
                <div className="row copyright" id="for_mobilftr">
                    <div className="col-lg-6 col-md-6">
                        <ul className="copyright-menu">
                            <li><Link to="/privacy">Privacy</Link></li>
                            <li><Link to="/terms">Terms and conditions</Link></li>
                        </ul>
                    </div>
                    <div className="col-lg-6 col-md-6">
                        <p className="copyright-txt">Copyright 2019 - EXCLUSIVE GULETS</p>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12 mb-3 d-flex justify-content-center">
                        <a href="http://www.myba-association.com/en/member-detail/member-list/341-exclusive-gulets-ltd.cfm">
                            <img 
                                src={mybaLogo} 
                                className="img-responsive"
                                style={{
                                    width: 180,
                                    margin: '0 auto'
                                }}
                            />
                        </a>    
                    </div>
                </div>
            </div>
        </section>

        );
    }
}

export default Footer;
